export function getIncrementedId(currId) {
    // "wrap around" IDs at some high threshold to prevent collisions
    return currId < 100000 ? currId + 1 : 0;
}
